import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(30, 46)};
  }

  ${HeadingSummaryBlockStyles.Subheading} {
    margin-bottom: ${fluid(8, 24)};
  }

  ${HeadingSummaryBlockStyles.Heading} {
    color: ${brand.primary.purple.light};
    font-size: ${fluid(32, 48)};
    line-height: ${fluid(40, 56)};
  }
`;
const Tabs = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const TabGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--gutterWidth);
  border-bottom: 10px solid ${brand.primary.purple.light};
`;
const Tab = styled.button `
  ${transition('background')};
  ${ButtonReset};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${fluid(8, 23)};
  background-color: ${brand.grey.lightest};
  padding: 14px 43px 17px;
  border-radius: ${fluid(5, 20)} ${fluid(5, 20)} 0 0;

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  &[aria-selected='true'] {
    background-color: ${brand.primary.purple.light};
  }
`;
const TabIcon = styled.div `
  ${transition('background')};

  --bgColour: ${brand.primary.blue.dark};

  height: ${fluid(70, 113)};
  width:  ${fluid(70, 113)};
  background-color: var(--bgColour);
  border-radius: 50%;
  color: ${brand.global.white};
  display: flex;
  align-items: center;
  justify-content: center;

  ${Tab}[aria-selected='false']:hover & {
    --bgColour: ${brand.primary.purple.light};
  }

  [aria-selected='true'] & {
    --bgColour: ${brand.primary.blue.dark};
  }

  svg {
    width:  ${fluid(30, 60)};
    height: ${fluid(30, 60)};
  }
`;
const TabTitle = styled.span `
  ${transition('color')};
  ${fonts.intro};

  --textColor: ${brand.primary.blue.dark};

  font-size: ${fluid(16, 24)};
  line-height: ${fluid(20, 28)};
  color: var(--textColor);

  ${Tab}[aria-selected='false']:hover & {
    --textColor: ${brand.primary.purple.light};
  }

  [aria-selected='true'] & {
    --textColor: ${brand.global.white};
  }
`;
const CardHolder = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: ${fluid(4, 19)};
`;
const Card = styled.div `

  @media ${from(Device.TabletLarge)} {
    grid-column: 1;
    grid-row: 1;

    &[data-active='false'] {
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }
  }  
`;
const PricingStyles = {
    Card,
    CardHolder,
    Container,
    Tab,
    TabIcon,
    Tabs,
    TabGrid,
    TabTitle,
};
export default PricingStyles;
